export default __webpack_public_path__ + "static/media/spirituality.c8152e29.svg";